export default "__VITE_ASSET__DVo$fPHA__"